import { mentionPropsForSemanticMention } from '#pplx/frontend/composer-sdk/internal/mention/mentionVariant.js';
import { $createMentionNode, $isMentionNode, } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNodeSupport.js';
import { $createParagraphNode, $createTextNode, $getRoot, $getSelection, $isElementNode, $isParagraphNode, $isRangeSelection, SKIP_DOM_SELECTION_TAG, } from 'lexical';
export function insertMention(editor, mention) {
    let result = 'inserted';
    editor.update(() => {
        const props = mentionPropsForSemanticMention(mention);
        if (hasMention($getRoot(), props.uuid, props.variant)) {
            result = 'duplicate';
            return;
        }
        const mentionNode = $createMentionNode(props);
        const spacer = $createTextNode(' ');
        const selection = $getSelection();
        if ($isRangeSelection(selection) && selection.isCollapsed()) {
            selection.insertNodes([mentionNode, spacer]);
            spacer.selectEnd();
            return;
        }
        const root = $getRoot();
        const lastChild = root.getLastChild();
        if ($isParagraphNode(lastChild)) {
            lastChild.append(mentionNode, spacer);
        }
        else {
            root.append($createParagraphNode().append(mentionNode, spacer));
        }
        spacer.selectEnd();
    }, {
        // Insertion updates Lexical's caret but must not take DOM focus from the host action.
        discrete: true,
        tag: SKIP_DOM_SELECTION_TAG,
    });
    return result;
}
function hasMention(node, id, variant) {
    if ($isMentionNode(node)) {
        return node.__props.uuid === id && node.__props.variant === variant;
    }
    return $isElementNode(node) && node.getChildren().some((child) => hasMention(child, id, variant));
}
//# sourceMappingURL=insertMention.js.map